<div *ngFor="let questionGroup of questionGroups">
    <div *ngIf="questionGroup && questionGroup.elements && questionGroup.elements.length" class="product-questions-container">
        <div *ngFor="let row of questionGroup.elements" class="product-questions-form-row">
            <div *ngFor="let cell of row" class="product-questions-form-cell {{cell.class}}">
                <product-question-element [element]="cell"></product-question-element>
            </div>
        </div>
    </div>
</div>